import React, { useEffect, useState } from 'react';
import * as mentorApi from '../../api/mentorApi';
import { statusLabel, statusPillClass } from './esgEvaluationUi';

// Read-only: members' self session-interest ratings next to the auditor's session and chair ratings.
export default function EsgRatings({ onError }) {
  const [squads, setSquads] = useState([]);
  const [squadId, setSquadId] = useState('');
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    mentorApi.getEsgEvaluationSquads()
      .then((list) => {
        setSquads(list);
        if (list.length > 0) setSquadId(String(list[0].id));
      })
      .catch(() => onError?.("Couldn't load squads - try again."))
      .finally(() => setLoading(false));
  }, [onError]);

  useEffect(() => {
    if (!squadId) {
      setRows([]);
      return undefined;
    }
    let cancelled = false;
    mentorApi.getEsgSquadRatings(squadId)
      .then((data) => {
        if (!cancelled) setRows(Array.isArray(data?.councils) ? data.councils : []);
      })
      .catch(() => {
        if (!cancelled) onError?.("Couldn't load ratings - try again.");
      });
    return () => {
      cancelled = true;
    };
  }, [squadId, onError]);

  return (
    <div className="animate-fade-in">
      <div className="dashboard-title-row">
        <h1>ESG Ratings</h1>
      </div>
      {loading ? (
        <div className="placeholder-card">Loading squads...</div>
      ) : squads.length === 0 ? (
        <div className="placeholder-card">No squads are assigned to you yet.</div>
      ) : (
        <>
          <div className="form-field-group esg-ratings__div-1">
            <label htmlFor="esg-ratings-squad">Squad</label>
            <select id="esg-ratings-squad" className="form-control-select" value={squadId} onChange={(e) => setSquadId(e.target.value)}>
              {squads.map((s) => (
                <option key={s.id} value={s.id}>{s.name}</option>
              ))}
            </select>
          </div>
          <div className="students-table-card">
            <table className="students-table">
              <thead>
                <tr>
                  <th>Council</th>
                  <th>Members' average</th>
                  <th>Rated by</th>
                  <th>Auditor: session</th>
                  <th>Auditor: chair</th>
                  <th>Status</th>
                </tr>
              </thead>
              <tbody>
                {rows.map((r) => (
                  <tr key={r.council_number}>
                    <td>{r.council_number === 0 ? 'Introduction' : `Council ${r.council_number}`}</td>
                    <td>{r.self_rating_average ?? '-'}</td>
                    <td>{r.self_rating_count} members</td>
                    <td>{r.session_rating ?? '-'}</td>
                    <td>{r.chair_rating ?? '-'}</td>
                    <td>
                      {r.evaluation_status
                        ? <span className={`status-pill ${statusPillClass(r.evaluation_status)}`}>{statusLabel(r.evaluation_status)}</span>
                        : '-'}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </>
      )}
    </div>
  );
}
